import React, { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

export function PageGuardKepalaSkb({
  children,
}: {
  children: React.ReactNode
}) {
  const { isKepalaSkb, isSuccess, leave } = useRoleContext()

  useEffect(() => {
    if (isSuccess && !isKepalaSkb) {
      leave()
    }
  }, [isSuccess, isKepalaSkb, leave])

  if (!isSuccess || !isKepalaSkb)
    return (
      <div className="flex p-10">
        <div className="m-auto">
          <Spinner data-testid="loading-spinner-content" />
        </div>
      </div>
    )

  return <>{children}</>
}
